import Vue from 'vue'
import VueRouter from 'vue-router';
import Hello from '../components/HelloWorld';
import Main from '../pages/mainContent.vue';

import Home from '../pages/home.vue';
import Search from '../pages/search.vue';
import Properties from '../pages/properties.vue';
import Help from '../pages/help.vue';
import User from '../pages/user.vue';
import Detail from '../pages/detail.vue';
import Search_t from '../pages/searchBytar.vue';
import Detail_t from '../pages/detail_t.vue';
import About from '../pages/about.vue';
import About_t from '../pages/about_t.vue';
import Network from '../pages/network.vue';
import Relationship from '../pages/relationship.vue';
import Predict from '../pages/predict.vue';
import Nav from '../pages/navigation.vue';
import Act from '../pages/upsmile.vue';
import Target from '../pages/uptarget.vue';
import Sendmail from '../pages/sendmail.vue';
import Upform from '../pages/upform.vue';
import Uptarform from '../pages/uptarform.vue';
import Download from '../pages/download.vue';

const routes = [
  { path: '/foo', component: Hello },
  { path: '/bar', component: Hello },

  { path: '/', redirect: '/main/home',name: '主页' },

  { path: '/main/', component: Main,
    children: [
      {
        path: 'home',
        component: Home
      },
      {
        path: '/search',
        component: Search
      },
      {
        path: '/properties',
        component: Properties
      },
      {
        path: '/searchBytar',
        component: Search_t
      },
      {
        path: 'search/detail',
        component: Detail
      },
      {
        path: 'searchBytar/detail_t',
        component: Detail_t
      },
      {
        path: 'search/about',
        component: About
      },
      {
        path: 'searchBytar/about_t',
        component: About_t
      },
      {
        path: '/predict',
        component: Predict
      },
      {
        path: '/network',
        component: Network
      },
	  {
	    path: '/relationship',
	    component: Relationship
	  },
	  
      {
        path: '/help',
        component: Help
      },
      {
      path: '/download',
      component: Download
      }
    ]
  },
  {
    path: '/main/data',
    component: Nav,
    children:[
      {
        path: 'upsmile',
        component:Act,
      },
      {
        path: 'upsmile/upform',
        name: 'upform',
        component:Upform
      },
      {
        path: 'uptarget/uptarform',
        name: 'uptarform',
        component:Uptarform
      },
      {
        path: 'sendmail',
        component: Sendmail
      },
      {
        path: 'uptarget',
        component:Target
      }
    ]
  }
];


const router = new VueRouter({
  routes
});



Vue.use(VueRouter);
// const originalPush = Router.prototype.push
// Router.prototype.push = function push(location) {
//   return originalPush.call(this, location).catch(err => err)
// }


export default router;
